import { createFileRoute, type SearchSchemaInput } from "@tanstack/react-router";
import { ReturnToStockPage } from "@charphq/ui/components/layout/pages/ReturnToStockPage";

export const Route = createFileRoute("/devices_/return-to-stock")({
  component: ReturnToStockComponent,
  // `ids`: comma-separated device ids to start with (the awaiting-return list links here).
  validateSearch: (search: Record<string, unknown> & SearchSchemaInput) => ({
    ids: typeof search.ids === "string" && search.ids ? search.ids : undefined,
  }),
});

function ReturnToStockComponent() {
  const { ids } = Route.useSearch();
  const initialIds = ids ? ids.split(",").filter(Boolean) : undefined;
  return <ReturnToStockPage key={ids ?? ""} initialIds={initialIds} />;
}
